import { HttpClient } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";
import { Bank } from "@data/schemas/bank";
import { DataList } from "@data/schemas/filter/data-list";
import { HttpParamsConfig } from "@shared/schemas/http-params-config";
import { BaseCrudBffService } from "@shared/services/base-crud-bff.service";
import { convertHttpParamsToQueryString } from "@shared/utils/filter-params-utils";
import { Observable, Subject } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class BankService {
	httpParamsCache = signal<HttpParamsConfig | undefined>(undefined);
	private refreshBanksSubject = new Subject<void>();
	refreshBanksSubject$ = this.refreshBanksSubject.asObservable();

	constructor(
		private baseCrudBff: BaseCrudBffService,
		private http: HttpClient
	) {}

	getBanks(httpParamsConfig?: HttpParamsConfig): Observable<DataList<Bank>> {
		const params = convertHttpParamsToQueryString({
			...httpParamsConfig,
			size: 10
		});

		return this.http.get<DataList<Bank>>("banks/all", {
			params: params,
			withCredentials: true
		});
	}

	getAllBanks(
		notAsaas = false,
		searchText = "",
		orderBy = "",
		notBaseBank = false,
		bankInstitution = ""
	): Observable<Bank[]> {
		return this.baseCrudBff.getAll<Bank[]>({
			path: "banks",
			params: {
				notAsaas,
				q: searchText,
				orderBy: orderBy,
				notBaseBank: notBaseBank,
				bankInstitution: bankInstitution
			}
		});
	}

	getById(id: number): Observable<Bank> {
		return this.http.get<Bank>(`banks/${id}`, {
			withCredentials: true
		});
	}

	setHttpParamsCache(params: HttpParamsConfig | undefined): void {
		this.httpParamsCache.set({ ...params });
	}

	refreshBanks(): void {
		this.refreshBanksSubject.next();
	}

	save(bank: Bank): Observable<DataList<Bank>> {
		return this.http.post<DataList<Bank>>(`banks`, bank, {
			withCredentials: true
		});
	}

	update(bank: Bank): Observable<Bank> {
		return this.http.put<Bank>(`banks/${bank.id}`, bank, {
			withCredentials: true
		});
	}

	delete(id: number): Observable<Bank> {
		return this.http.delete<Bank>(`banks/${id}`, {
			withCredentials: true
		});
	}
}
